export default "__VITE_ASSET__B6l0a2zG__"